import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroupDirective, NgForm} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import {Router} from '@angular/router';
import {Ordered} from 'src/app/models/ordered';
import {AuthService} from 'src/app/services/auth.service';
import {FrontDeskService} from 'src/app/services/front-desk.service';
import {MemberService} from 'src/app/services/member.service';
import {ProductCatPriceService} from 'src/app/services/product-cat-price.service';
import {ProductLotService} from 'src/app/services/product-lot.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-front-desk-products',
  templateUrl: './front-desk-products.component.html',
  styleUrls: [ './front-desk-products.component.scss' ]
})
export class FrontDeskProductsComponent implements OnInit {

  public spinner: boolean;
  public current_price: any = {};

  //public requirementPass: boolean;
  //public arrayHandsOnTopics: any[] = []
  //public handsOnTopicSelected: any = {}

  //public frontDeskCategories: any[] = []

  /////////////////////////////////
  //public value_balance: number = 0;
  public value_subscription: number = 0;
  public value_defaulting: number = 0;

  public value_total: number = 0;
  public op1_value_total: number = 0;
  public op2_value_total: number = 0;

  //public value_total_us: number = 0;
  //pubserSubscription52lic op1_value_total_us: number = 0;
  //public op2_value_total_us: number = 0;

  public totalDebit: number = 0;
  public totalPlots: number = 0;
  public isAnnuityFree: boolean = false;
  public annuities: any[] = [];
  public haveDebts: boolean = false;

  public waiting: any;

  constructor (
    public _authService: AuthService,
    public _frontDeskService: FrontDeskService,
    private _productCatPriceService: ProductCatPriceService,
    private router: Router,
    private _productLotService: ProductLotService,
    private _memberService: MemberService
  ) {

    //if (!this._frontDeskService.currentMember || !this._frontDeskService.currentProduct) {
    //  this.router.navigate([ 'front-desk' ]);
    //}

    //this._frontDeskService.nonMemberCategory = null

    //this.loadFrontDeskCategories()

    //// verifica se é sócio
    //if (this._frontDeskService.currentMember.subCategory.id == 'H2AoWhktluQaWYuPydHC') {
    //  this.isNoPartner = true
    //} else {
    //  this.isNoPartner = false
    //this.priceCategory = this._frontDeskService.currentMember.subCategory.id

    if (this._frontDeskService.currentMember) {
      this.getSituation(this._frontDeskService.currentMember)
    } else {
      this.router.navigate([ 'front-desk' ]);
    }


    //this.getPrice()
    //}

    //  this.requirements()

  }

  ngOnInit () {
  }

  async getSituation (member: any) {

    //console.log('getSituation: ' + member.id)
    //this.waiting = this._spinnerService.show();
    this.spinner = true;

    const result = await this._memberService.getMemberAllAnnuitiesAdmin(member.id);

    console.log('getMemberAllAnnuitiesAdmin: ' + JSON.stringify(result))
    
    this.totalDebit = 0;
    this.annuities = []

    result.payedAnnuities.forEach((annuity: any) => {
      if (!annuity.order) {
        this.annuities.push(annuity)
      }
    });

    //this.annuities = result.payedAnnuities
    this.totalDebit = result.totalDebit
    this.haveDebts = result.totalDebit > 0 ? true : false
    this.totalPlots = result.totalPlots
    this.isAnnuityFree = result.isAnnuityFree

    //this.value_balance  = result.totalDebit

    /*
    console.log('annuities: ' + JSON.stringify(this.annuities))
    console.log("this.annuities.length: " + this.annuities.length)
    console.log("this.totalDebit: " + this.totalDebit)
    console.log("this.isAnnuityFree: " + this.isAnnuityFree)
    console.log("this.haveDebts: " + this.haveDebts)
    */

    this.getPrice()

    /*
    await this._memberService.getMemberAllAnnuitiesAdmin(member.id)
      .then(async (result) => {

        this.totalDebit = 0;
        this.annuities = []

        result.data.payedAnnuities.forEach((annuity) => {
          if (!annuity.order) {
            this.annuities.push(annuity)
          }
        })

        this.totalDebit = result.data.totalDebit
        this.haveDebts = result.data.totalDebit > 0 ? true : false
        this.totalPlots = result.data.totalPlots
        this.isAnnuityFree = result.data.isAnnuityFree

        this.getPrice()

      })
    */
  }


  getPrice () {

    const product_id = this._frontDeskService.currentProduct.id
    const category_id = this._frontDeskService.currentMember.subCategory.id

    console.log('product_id: ' + product_id)
    console.log('category_id: ' + category_id)

    this.value_subscription = 0;
    this.value_defaulting = 0;

    this.value_total = 0;
    this.op1_value_total = 0;
    this.op2_value_total = 0;

    //this.value_total_us = 0;
    //this.op1_value_total_us = 0;
    //this.op2_value_total_us = 0;

    this._productLotService.loadLots(product_id)
      .subscribe((result) => {
        let arrayLot: any[] = []
        result.forEach((item) => {
          let dt: any = item.data().until_date
          arrayLot.push({
            'id': item.id,
            'name': item.data().name,
            "until_date": dt.toDate()
          })
        })
        arrayLot.sort(this.compareDates)
        arrayLot.forEach((item) => {
          if (item.until_date > new Date()) {
            this.loadProductCatPrices(item.id, category_id, product_id)
            return;
          }
        })

      })
  }

  loadProductCatPrices (lot_id, category_id, product_id) {

    this._productCatPriceService.loadCatPrices(product_id, lot_id)
      .subscribe((result) => {
        result.forEach((item) => {

          item.data().categories.forEach((cat) => {

            if (category_id == cat.id) {
              this.current_price = {
                'lot_name': item.data().name,
                'category_id': cat.id,
                'category_name': cat.name,
                'value': item.data().value,
                'value_defaulting': item.data().value_defaulting
              }

            }

          })

        })
        this.calculaFinalValue()
      })


  }

  calculaFinalValue () {

    if (this.annuities.length > 0) {

      this.value_defaulting = Number(this.current_price.value_defaulting)
      this.value_subscription = Number(this.current_price.value)

      this.op1_value_total = this.totalDebit + this.value_subscription

      this.op2_value_total = this.current_price.value_defaulting

    } else if (this.annuities.length == 0) {

      //console.log('+++++++++++++++++++++++++++++++++')
      //console.log("this.current_price.value: " + this.current_price.value)

      this.value_subscription = this.current_price.value
      this.value_total = this.current_price.value
      console.log("value total: " + this.value_total)

    }

    this.spinner = false;
    //this.waiting.close();

  }

  compareDates (b, a) {
    if (a.until_date > b.until_date) return 1;
    if (b.until_date > a.until_date) return -1;
    return 0;
  }

  createOrderAnnuityOk () {
    //console.log('createOrderAnnuityOk')
    let order = this._frontDeskService.createOrder(false, 0, this.value_subscription, this.value_total, 'front-desk')
    //console.log("order: " + JSON.stringify(order))

    this.gotoConfirmation(order, false)
    //register order
    //send email

  }

  createOrderWithAnnuities () {
    //console.log('createOrderWithAnnuities')
    let order = this._frontDeskService.createOrder(false, this.totalDebit, this.value_subscription, this.op1_value_total, 'front-desk')
    //console.log("order: " + JSON.stringify(order))

    this.gotoConfirmation(order, true)

    //register order
    //update member
    //send email

  }

  createOrderWithoutAnnuities () {
    //console.log('createOrderWithoutAnnuities')
    let order = this._frontDeskService.createOrder(true, this.totalDebit, this.value_defaulting, this.op2_value_total, 'front-desk')
    //console.log("order: " + JSON.stringify(order))

    this.gotoConfirmation(order, false)

    //register order
    //send email

  }

  gotoConfirmation (ordered: Ordered, updateMemberSituation: boolean) {

    this._frontDeskService.currentOrdered = ordered
    this._frontDeskService.updateMemberSituation = updateMemberSituation

    this.router.navigate([ 'front-desk-confirmation' ]);
  }

  goBack () {
    this.router.navigate([ 'front-desk-orders' ]);
    const value = this.op2_value_total
  }


  /*

  requirements () {

    if (this._frontDeskService.currentProduct.requirements.length > 0) {
      let flag: any;

      this.checkRequirements()
        .then((checkReqs) => {

          flag = checkReqs.find((e) => {
            return e.check == false
          })

          if (flag) {
            this.showRequirements(false)
          } else {
            this.showRequirements(true)
          }

        })
    } else {
      this.showRequirements(true)
    }
  }

  async checkRequirements (): Promise<any> {
    let requirements = this._frontDeskService.currentProduct.requirements
    let member_id = this._frontDeskService.currentMember.id

    let arrayRequirements: any[] = []
    for (const requirement of requirements) {

      await new Promise(resolve => {
        this._frontDeskService.checkRequirements(member_id, requirement.product_id)
          .subscribe((result: any) => {

            if (result.docs.length == 0) {
              arrayRequirements.push({'check': false})
            } else {
              arrayRequirements.push({'check': true})
            }

            resolve({});
          });

      });
    }

    return arrayRequirements

  }

  showRequirements (flag: boolean) {
    this.requirementPass = flag
    if (this.requirementPass) {
      console.log("pré-requisito ok")
      this.loadProductLotsPrices(this._frontDeskService.currentProduct.id)
    } else {
      console.log("não tem pré-requisito")
      console.log(this._frontDeskService.currentProduct.requirements[ 0 ].product_name)
    }

  }

  */

  //loadFrontDeskCategories () {

  //this.frontDeskCategories = this._frontDeskService.selectSubcategoriesFrontDesk()
  /*
  this._frontDeskService.selectSubcategoriesFrontDesk()
  .subscribe((result)=>{
    result.forEach((item)=>{
      this.frontDeskCategories.push({
        'id': item.id,
        'name': item.data().name
      })
    })
  })
  */

  //}

  //getCategory () {
  //  console.log("getCategory: " + this.priceCategory)
  // let cat = this.frontDeskCategories.find((e) => {
  //return e.id == this.priceCategory
  // })

  //this._frontDeskService.nonMemberCategory = cat

  //   console.log(JSON.stringify(this._frontDeskService.nonMemberCategory))

  //this.getPrice()
  //}

  /*
  _getSituation(member){
    this.waiting = this._spinnerService.show();
    this.getMemberAllAnnuitiesAdmin(member.id)
    .then(async (result)=>{
      console.log('getMemberAllAnnuitiesAdmin: ' + JSON.stringify(result))
    })
  }
  */

}